import {  createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  CondimentInterface,
  CondimentState,
  ToggleCondimentPayload,
} from "../../entities/Condiment";
import { fetchCondiments, fetchHarmonyCondiments } from "./actions";

const initialState: CondimentState = {
  isLoading: false,
  error: undefined,
  data: {
    condiments: [],
  },
};

const condimentSlice = createSlice({
  name: "condimentSlice",
  initialState,
  reducers: {
    setCondiments: (
      state: CondimentState,
      action: PayloadAction<CondimentInterface[]>,
    ) => {
      state.data.condiments = action.payload.map((item) => ({
        ...item,
        meta: {
          ...item.meta,
          grams: item.weight,
          percentage: item.percentage ?? 1,
          parts: item.parts ?? 1,
          selected: true,
        },
      }));
    },
    setCondiment: (
      state: CondimentState,
      action: PayloadAction<CondimentInterface>,
    ) => {
      state.data.condiments = [
        ...state.data.condiments,
        {
          ...action.payload,
          meta: {
            ...action.payload.meta,
            grams: action.payload.weight,
            percentage: action.payload.percentage ?? 1,
            parts: action.payload.parts ?? 1,
            selected: true,
            hidden: true,
          },
        },
      ];
    },
    toggleCondiment: (
      state: CondimentState,
      action: PayloadAction<ToggleCondimentPayload>,
    ) => {
      const condiments = [...state.data.condiments];
      const indexOfElement = condiments.findIndex(
        (item) => item.id === action.payload.id,
      );
      const transformedElement = condiments[indexOfElement];
      transformedElement.meta.selected = !transformedElement.meta.selected;
      condiments[indexOfElement] = transformedElement;

      state.data.condiments = condiments;
    },
    clearSelectedCondiments: (state: CondimentState) => {
      const clonedCondiments = [...state.data.condiments];
      state.data.condiments = clonedCondiments.map((item) => ({
        ...item,
        meta: {
          ...item.meta,
          selected: false,
        },
      }));
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCondiments.pending, (state: CondimentState) => {
        state.isLoading = true;
        state.error = undefined;
      })
      .addCase(fetchCondiments.fulfilled, (
        state: CondimentState,
        action: PayloadAction<CondimentInterface[]>,
      ) => {
        state.isLoading = false;
        state.data.condiments = action.payload;
      })
      .addCase(fetchCondiments.rejected, (
        state: CondimentState,
        action
      ) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(fetchHarmonyCondiments.pending, (state: CondimentState) => {
        state.isLoading = true;
        state.error = undefined;
      })
      .addCase(fetchHarmonyCondiments.fulfilled, (
        state: CondimentState,
        action: PayloadAction<CondimentInterface[]>,
      ) => {
        state.isLoading = false;
        state.data.condiments = action.payload;
      })
      .addCase(fetchHarmonyCondiments.rejected, (
        state: CondimentState,
        action
      ) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const {
  setCondiments,
  setCondiment,
  toggleCondiment,
  clearSelectedCondiments,
} = condimentSlice.actions;

export default condimentSlice.reducer;
